import { atom } from "recoil";

export type LoginMethod = "apple" | "google" | "kakao";

const STORAGE_KEY = "login_hint";

const isLoginMethod = (v: unknown): v is LoginMethod =>
  v === "apple" || v === "google" || v === "kakao";

// 앱(WebView) 로그인 화면 소셜 버튼에 "최근 로그인" 라벨로 표시할 "마지막 로그인 수단".
// 소스: (1) OneLink 딥링크, (2) 실제 로그인(userAtom.authenticateType). useReceiveLoginHint 참고.
// localStorage 영속 → 앱 재시작/로그아웃에도 유지된다.
export const loginHintAtom = atom<LoginMethod | undefined>({
  key: "loginHint",
  default: undefined,
  effects: [
    ({ setSelf, onSet }) => {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (isLoginMethod(saved)) setSelf(saved);

      onSet((newValue, _, isReset) => {
        isReset || !isLoginMethod(newValue)
          ? localStorage.removeItem(STORAGE_KEY)
          : localStorage.setItem(STORAGE_KEY, newValue);
      });
    },
  ],
});
